<nav class="nav nav-pills flex-column" id="reports-menu">
  @for (item of navItems; track item) {
    <a
      class="nav-item nav-link"
      id="{{item.id}}-tab-menu"
      [class.active]="currentTab == item.id"
      [routerLink]="['/reports/' + item.id]">
      {{item.title}}
    </a>
  }
</nav>
